import React from "react"
import { Outlet } from 'react-router-dom'
import FacilityPanel from './Facility'

export default function Page({ user, facility, setFacility }) {
  return (
    <>
      <FacilityPanel activeFacility={facility} setFacilityActive={setFacility}/>
      {facility && <Outlet/>}
    </>
  )
}